/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef, useEffect, Suspense } from 'react'
import { useGLTF, useAnimations, Html, SpotLight, useHelper } from '@react-three/drei'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLink
} from "@fortawesome/free-solid-svg-icons";


import { Finalboards } from './Finalboards.jsx';
import { Gates }  from './Gates.jsx';


export function Last({mode},props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/LastModel.glb')
  const { actions, names } = useAnimations(animations, group)
  const [scale, setScale] = React.useState(1);
  const [pos, setPos] = React.useState([0,0,200]);

  
  useEffect(() => {
    // Reset and fade in animation after an index has been changed
    
    actions[names].reset().fadeIn(0.5).play()
    actions[names].timeScale = 0.15
 
    // In the clean-up phase, fade it out
   
  }, [ actions, names])

//   useEffect(()=>{
// if(window.innerWidth<900){
//   setScale(0.5)
//   setPos([0,0,100])
// }
//   },[])


  return (
    <group ref={group} scale={[scale,scale,scale]} {...props} dispose={null} position={pos}>
      <group name="Scene">

      {/* <Boards newsClick={()=>{
        props.newsClick()}}
        /> */}

      < Gates />  

      <Finalboards mode={mode} newsClick={()=>{
        props.newsClick()}}/>  

        <mesh
          name="acochill_stage_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_stage_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0.535, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_table_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_table_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_entrance_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_entrance_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_bushes_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_bushes_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_stall_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_stall_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0.511, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_highground_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_highground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_footballground_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_footballground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_streetLamp_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_streetLamp_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="achchill_car_geo"
          castShadow
          receiveShadow
          geometry={nodes.achchill_car_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_props_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_props_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_campground_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_campground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_texture_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_texture_geo.geometry}
          material={materials.acochillcamp_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_stage_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_stage_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_endEntrance_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_endEntrance_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_path_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_path_geo.geometry}
          material={materials.mt_100path_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_lake_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_lake_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_pinetree_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_pinetree_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_barriergates_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_barriergates_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_tents_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_tents_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_racetrack_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_racetrack_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_racetracklines_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_racetracklines_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_building_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_building_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_gates_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_gates_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_dummycar_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_dummycar_geo.geometry}
          material={materials['dummycar_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_texture"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_texture.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_highground_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_highground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_regionportlogo_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_regionportlogo_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_lightlamp_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_lightlamp_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_basetress_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_basetress_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_building_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_building_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_basebushes_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_basebushes_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_base_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_base_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_trackbase_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_trackbase_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_building2base_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_building2base_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_light_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_light_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_umbrella_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_umbrella_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_train_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_train_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_cyclestation_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_cyclestation_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_lighthouse_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_lighthouse_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_deco_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_deco_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_busstand_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_busstand_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="trailstation_dummycar_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_dummycar_geo.geometry}
          material={materials['dummycar_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_treetrunk_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_treetrunk_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mt_fuji_geo"
          castShadow
          receiveShadow
          geometry={nodes.mt_fuji_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_fence_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_fence_geo.geometry}
          material={materials.plane_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_road_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_road_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_bigstones_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_bigstones_geo.geometry}
          material={materials.mt_100path_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_stones_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_stones_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_tree2_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_tree2_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_ground_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_ground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_road_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_road_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_plane1_static_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_plane1_static_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_runwaylines_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_runwaylines_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_tower_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_tower_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_pickuptruck_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_pickuptruck_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_bus_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_bus_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_texture_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_texture_geo.geometry}
          material={materials.acochillcamp_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_hangar_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_hangar_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="regionportlogo_geo"
          castShadow
          receiveShadow
          geometry={nodes.regionportlogo_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[80.532, 8.136, -510.971]}
          rotation={[Math.PI, -Math.PI/5, Math.PI]}
          scale={0.08}
        >

        </mesh>
        <mesh
          name="airport_car_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_car_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_plane_static_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_plane_static_geo.geometry}
          material={materials.plane_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_plane1_fan_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_plane1_fan_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, -52.722, -92.951]}
          scale={0.025}
        />
        <mesh
          name="airport_R_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_R_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
       
        <mesh
          name="mtfuji100_rocks_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_rocks_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_mt_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_mt_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="interprotoseries_ground_geo"
          castShadow
          receiveShadow
          geometry={nodes.interprotoseries_ground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_dummycar_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_dummycar_geo.geometry}
          material={materials['dummycar_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_strawwolf_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_strawwolf_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 1.089, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_directionsignboard_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_directionsignboard_geo.geometry}
          material={materials.acochillcamp_tex}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill_whiskytank_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_whiskytank_geo.geometry}
          material={materials['whisky_tex.001']}
          position={[0, 0.511, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_sandground_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_sandground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_greenground_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_greenground_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_roadcornors_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_roadcornors_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="acochill__umbrella_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill__umbrella_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_pinetree_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_pinetree_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[-91.758, 0, -92.951]}
          scale={0.025}
        />
        <mesh
          name="RGP_pine2tree_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_pine2tree_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[-64.8, 0.703, 7.758]}
          scale={0.01}
        />
        <mesh
          name="ads_plane_fan_geo"
          castShadow
          receiveShadow
          geometry={nodes.ads_plane_fan_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[521.246, 88.298, -354.746]}
          rotation={[0.793, -1.325, 0.778]}
          scale={0.032}
        />
        <mesh
          name="trailstation_building2_geo"
          castShadow
          receiveShadow
          geometry={nodes.trailstation_building2_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[-329.323, 10.874, -91.779]}
          scale={0.025}
        />
        <mesh
          name="RGP_tree_geo"
          castShadow
          receiveShadow
          geometry={nodes.RGP_tree_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[0, 0, -92.75]}
          scale={0.025}
        />
        <mesh
          name="mtfuji100_rock_geo"
          castShadow
          receiveShadow
          geometry={nodes.mtfuji100_rock_geo.geometry}
          material={materials['rgp_tex.005']}
          position={[0, 0, -92.276]}
          scale={0.025}
        />
  
        <group
          name="ads_plane_geo001"
          position={[551.754, 88.951, -267.644]}
          rotation={[0.871, -1.355, 0.883]}
          scale={0.06}
        />
        <group
          name="airbaloon_geo"
          position={[504.44, 143.623, -307.807]}
          rotation={[Math.PI, -0.072, Math.PI]}
          scale={0.025}>
          <mesh
            name="Mesh116"
            castShadow
            receiveShadow
            geometry={nodes.Mesh116.geometry}
            material={materials['rgp_tex.003']}
          >
            { mode === "night" && <pointLight castShadow={false} intensity={20000} color={'orange'} position={[-10,-10,-220]}/> }
            </mesh>
          <mesh
            name="Mesh116_1"
            castShadow
            receiveShadow
            geometry={nodes.Mesh116_1.geometry}
            material={materials['acochillcamp_tex.001']}
          >
             <Html distanceFactor={550} position={[-5.4, 3.5, 3.4]}>
            <div
              id="container-airport"
              style={{ height: "37px", width: "37px" }}
            >
              <a href="https://acochill.com/" target='_blank'>
                <FontAwesomeIcon style={{color:"white"}} icon={faLink} className="icon-link" />
              </a>
            </div>
           </Html>
            </mesh>
        </group>
        <group name="NurbsPath" position={[365.709, 190.697, -229.267]} />
        <mesh
          name="verticalartpiece_geo"
          castShadow
          receiveShadow
          geometry={nodes.verticalartpiece_geo.geometry}
          material={materials.VERTICALARTPIECE}
          position={[2.215, 5.376, 47.821]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[0.031, 0.003, 0.031]}
        />
        <mesh
          name="acochill_lights_geo"
          castShadow
          receiveShadow
          geometry={nodes.acochill_lights_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[2.362, 6.053, 55.799]}
          scale={0.025}
        />
        <mesh
          name="acochill_emi"
          castShadow
          receiveShadow
          geometry={nodes.acochill_emi.geometry}
          material={materials.acochill_emi}
          position={[2.219, 9.143, 56.473]}
          scale={0.025}
        />
        <mesh
          name="airport_sightseeingplane_fan_geo001"
          castShadow
          receiveShadow
          geometry={nodes.airport_sightseeingplane_fan_geo001.geometry}
          material={materials.rgp_tex}
          position={[-147.363, 3.673, -571.437]}
          rotation={[0, 0.314, -1.047]}
          scale={0.036}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/LastModel.glb')
